// extracted by mini-css-extract-plugin
module.exports = {"card":"dashboardListingCard_card__1e2zF","cardBody":"dashboardListingCard_cardBody__2DmZ9","cardHeader":"dashboardListingCard_cardHeader__2p_YR"};